import { render, staticRenderFns } from "./BarEchartsHorTwo.vue?vue&type=template&id=78e3d7d6"
import script from "./BarEchartsHorTwo.vue?vue&type=script&lang=js"
export * from "./BarEchartsHorTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports